import { AssetModelData } from "../../files/asset.interface";
import { FileObject } from "../../files/file-object";
import { LayoutNode } from "./layout.interface";
import { resolveAssetPaths } from "./resolve-asset-paths";
import { deepFindFiles } from "./util/deep-find-files";

/**
 * Resolve every file object that references an asset (by `assetId`) against
 * the given asset list. Mutates the file objects in place.
 */
export const replaceFileAssets = (
  files: FileObject[],
  assets: AssetModelData[]
) => {
  for (const file of files) {
    if (file.assetId) {
      const asset = assets.find((a) => a.id === file.assetId);

      if (asset) {
        Object.assign(file, resolveAssetPaths(file, asset));
      }
    }
  }
  return files;
};

export const replaceLayoutAssets = (
  views: LayoutNode[],
  assets: AssetModelData[]
) => {
  replaceFileAssets(deepFindFiles(views), assets);
  return views;
};
